
export function timeSpanFormat(timeSpan: string) {
        
    const timeSpanParsed = timeSpan.match(/P(\d+)?D?T(\d+)([A-Z])?(\d+)?([M|S])?(\d+)?([S])?/)
    let result = ''
    if (timeSpanParsed != null) {
        
        if (typeof timeSpanParsed[1] == 'string') {
            result += `${timeSpanParsed[1]} day(s) ` 
        }

        const tM = ['H','M','S']

        return result + timeSpanParsed.slice(2, 8).map((v, idx, source) => {

            if (idx % 2 == 1 && v != undefined) {
                const tMIdx = tM.indexOf(v)
                const time = parseInt(source[idx-1]) < 10 ? `0${source[idx-1]}` : source[idx-1]

                const gap = idx - (idx > 2 ? 2 : 1)
                if (tMIdx > gap && tMIdx - gap > 0) {
                    const d = (new Array(tMIdx - gap).fill('00'))
                    d.push(time)
                    return d.join(':') 
                } else {
                    return time + (idx + 1 < source.length ? ':' : '') 
                }
            }
            return ''
        }).join('')
    }
    return result
}